import { render, staticRenderFns } from "./spaceManagement.vue?vue&type=template&id=b19e4f46&scoped=true&"
import script from "./spaceManagement.vue?vue&type=script&lang=js&"
export * from "./spaceManagement.vue?vue&type=script&lang=js&"
import style0 from "./spaceManagement.vue?vue&type=style&index=0&id=b19e4f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19e4f46",
  null
  
)

export default component.exports